import moment from 'moment';
import { FocusEvent, useContext, useEffect, useMemo, useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import { toast } from 'react-toastify';
import { AppContext } from '../../../../appContext/AppContext';
import ButtonIn from '../../../../component/button-in-phieu';
import DanhSachPhieu from '../../../../component/DanhSachPhieu';
import LabelRequired from '../../../../component/LabelRequired';
import { TableCollapseCustom } from '../../../../component/table/table-collapse/TableCollapseCustom';
import ModalThucHien from '../../../../phan-he-chuyen-khoa/components/modal-thuc-hien/ModalThucHienChuyenKhoa';
import { createObsValue } from '../../../../phan-he-chuyen-khoa/services/PhanHeChuyenKhoaService';
import { deleteDSChiDinhDV, getDSDVDaChiDinh, getSurgeryIndicationInfo, updateOrderGroupFields } from '../../../../phan-he-kham-benh/services/ChiDinhDVService';
import { inPhieuChiDinhChung, inPhieuChiDinhCLS } from '../../../../phan-he-kham-benh/services/PrintExportService';
import { IDanhSachDanhMuc } from '../../../../phan-he-tiep-nhan-thanh-toan/models/TiepDonModel';
import { CODE, KEY, KEY_DS_DANH_MUC_TIEP_DON, MENU_ACTION, ORDER_TYPE_ID, RESPONSE_MESSAGE, STATUS_CANCEL, TERM_TYPE } from '../../../../utils/Constant';
import { getIndexedDBItem } from '../../../../utils/IndexedDB';
import WfButton from '../../../../workflows/components/WfButton';
import { WfConstTracker, WfConstTrackerClinical } from '../../../../workflows/Constant';
import { usePhanHeNoiTruContext } from '../../../PhanHeNoiTruContext';
import { getDsPhieuDichVu } from '../../../services/HanhChinhServices';
import { WORKFLOW_ORDER_GROUP_STATUS_CODE } from '../../../../phan-he-kham-benh/constants/ChiDinhDVConst';
import WfContextMenu from '../../../../workflows/components/WfContextMenu';
import { getPaymentDetail } from '../../../../phan-he-vien-phi/services/PhanHeVienPhiServices';
import DynamicComponentXN from '../../../../phan-he-xet-nghiem/components/DynamicComponentXN';
import { cancelService } from '../../../../utils/ServicesUtils';
import CellFormatter from '../../../../component/cell-formatter';
import TextField from '../../../../component/TextField';
import { Formik } from 'formik';
import { TableCustomCell } from '../../../../component/table/components/TableCustomCell';
import { getWorkflowTrackerFieldConfig } from '../../../../workflows/utils';
import { useIndicationInfo } from '../../../../phan-he-kham-benh/hooks/useIndicationInfo';
import { getStatusDesc } from 'src/app/modules/phan-he-kham-benh/services/KhamBenhService';
import CheckIcon from 'src/app/modules/phan-he-kham-benh/components/CheckIcon';
import ShowStatus from 'src/app/modules/component/ShowStatus';
import { TimeEditor } from 'src/app/modules/component/time-editor/TimeEditor';
import { useTimeEditorManager } from 'src/app/modules/component/time-editor/useTimeEditorManager';
import { hasAuthority, KEY_AUTHORITIES } from 'src/app/modules/utils/Permission';
import { ModalChonNgay } from '../../../../phan-he-kham-benh/modals/modal-ke-thuoc/components/NgayKeTuDong';
import { cloneParaclinical } from '../../../services/Common';
import { getErrorMessage } from 'src/app/modules/utils/FormatUtils';
import { ConfirmDialog } from 'src/app/modules/component/ConfirmDialog';
import { SelectEditor, useSelectEditorManager } from 'src/app/modules/component/select-editor';
import { seachUserMetadata } from 'src/app/modules/auth/core/_requests';
import useIndexDBValue from 'src/app/hook/useIndexDBValue';

type Props = {
  treatmentSheetId?: string
  allowOrder?: boolean
}

const ChuyenKhoa = ({ treatmentSheetId, allowOrder = true }: Props) => {
  const { setIsLoading } = useContext(AppContext);
  const { benhNhanHanhChinh, statusChangedEvent, statusChangedEventFunc } = usePhanHeNoiTruContext();
  const [dsPhieu, setDsPhieu] = useState<any[]>([]);
  const [selectedPhieu, setSelectedPhieu] = useState<any>(null);
  const [dsDichVuDetail, setDsDichVuDetail] = useState<any[]>([]);
  const [dynamicData, setDynamicData] = useState<any>(null);
  const [shouldOpenResultModal, setShouldOpenResultModal] = useState<boolean>(false);
  const [isHasData, setIsHasData] = useState<boolean>(false);
  const [selectedRow, setSelectedRow] = useState<any>(null);
  const [listICD10, setListICD10] = useState<any>([]);
  const [selectedIndex, setSelectedIndex] = useState<any>(0);
  const [isUpdateWorkflow, setIsUpdateWorkflow] = useState(false);
  const [currentStatusWf, setCurrentStatusWf] = useState<string>();
  const [statusDesc, setStatusDesc] = useState<any>([]);

  const [rowSelected, setRowSelected] = useState<any>();
  const [contextMenu, setContextMenu] = useState<null | {
    x: number;
    y: number;
  }>(null);
  const [itemService, setItemService] = useState<any>(null);
  const [openModalTachPhieu, setOpenModalTachPhieu] = useState(false);
  const [selectedPhieuForClone, setSelectedPhieuForClone] = useState<any>(null);
  const [generalInfo, setGeneralInfo] = useState<any>(null);
  const [thongTinChiPhi, setThongTinChiPhi] = useState<any>({
    tongChiPhi: 0,
    bhyt: 0,
    benhNhan: 0,
    tamUng: 0,
    daThu: 0,
    mienGiam: 0,
    conDu: 0,
  });
  const [fieldLoading, setFieldLoading] = useState<any>({});
  const [currentTreatmentId, setCurrentTreatmentId] = useState<string>(benhNhanHanhChinh?.treatmentId);
  const [validateMessage, setValidateMessage] = useState<string>('');
  const [shouldOpenConfirmDialog, setShouldOpenConfirmDialog] = useState<boolean>(false);

  const { value: danhSachDanhMuc } = useIndexDBValue<IDanhSachDanhMuc>({
    key: KEY_DS_DANH_MUC_TIEP_DON,
  });

  const allowEdit = !benhNhanHanhChinh?.concluded && hasAuthority(KEY_AUTHORITIES.UPDATE_FIELDS.PHIEU_CHI_DINH);

  //  Sử dụng custom hook để load indication info
  const { loadIndicationInfo } = useIndicationInfo({
    getIndicationInfo: getSurgeryIndicationInfo
  });

  //  Sử dụng custom hook để quản lý indication time
  const indicationTimeManager = useTimeEditorManager({
    name: "indicationTime",
    values: selectedPhieu,
    updateFields: updateOrderGroupFields,
    onUpdateSuccess: (updatedData) => {
      if (!updatedData?.indicationTime) return;
      // Cập nhật selectedPhieu với data mới
      setSelectedPhieu((prev: any) => ({
        ...prev,
        indicationTime: updatedData.indicationTime
      }));

      // Cập nhật trong danh sách phiếu
      setDsPhieu((prevList: any[]) =>
        prevList.map((phieu: any) =>
          phieu.id === selectedPhieu?.id
            ? { ...phieu, indicationTime: updatedData.indicationTime, date: moment(updatedData.indicationTime).format("DD/MM/YYYY") }
            : phieu
        )
      );
    }
  });

  const indicationPersonSelectManager = useSelectEditorManager({
    name: "indicationPerson",
    idFieldName: "id",
    values: selectedPhieu,
    updateFields: updateOrderGroupFields,
    buildPayload: (option) => ({
      indicationPerson: option?.fullName,
      indicationTime: selectedPhieu?.indicationTime
    }),
    onUpdateSuccess: (updatedData) => {
      if (!updatedData?.indicationPerson) return;
      // Cập nhật selectedPhieu với data mới
      setSelectedPhieu((prev: any) => ({
        ...prev,
        indicationPerson: updatedData.indicationPerson
      }));

      // Cập nhật trong danh sách phiếu
      setDsPhieu((prevList: any[]) =>
        prevList.map((phieu: any) =>
          phieu.id === selectedPhieu?.id
            ? { ...phieu, indicationPerson: updatedData.indicationPerson }
            : phieu
        )
      );
    },
    enableConfirmWithReason: false, // Không dùng confirm with reason cho trường hình thức
  });

  const requestDeptNameSelectManager = useSelectEditorManager({
    name: "requestDeptName",
    idFieldName: "id",
    values: selectedPhieu,
    updateFields: updateOrderGroupFields,
    buildPayload: (option) => ({
      requestDeptCode: option?.code,
      requestDeptName: option?.name,
      indicationTime: selectedPhieu?.indicationTime
    }),
    onUpdateSuccess: (updatedData) => {
      if (!updatedData?.requestDeptName) return;
      // Cập nhật selectedPhieu với data mới
      setSelectedPhieu((prev: any) => ({
        ...prev,
        requestDeptName: updatedData.requestDeptName
      }));

      // Cập nhật trong danh sách phiếu
      setDsPhieu((prevList: any[]) =>
        prevList.map((phieu: any) =>
          phieu.id === selectedPhieu?.id
            ? { ...phieu, requestDeptName: updatedData.requestDeptName }
            : phieu
        )
      );
    },
    enableConfirmWithReason: false,
  });

  useEffect(() => {
    setGeneralInfo({
      patient: {
        ...benhNhanHanhChinh,
        id: benhNhanHanhChinh?.patientId,
        code: benhNhanHanhChinh?.patientCode,
        personName: benhNhanHanhChinh?.patientName
      },
      visit: {
        ...benhNhanHanhChinh,
        ...thongTinChiPhi,
        id: benhNhanHanhChinh?.visitId
      },
      encounter: {
        id: rowSelected?.obs?.encounterId
      },
      orderId: rowSelected?.orderId,
      orderGroupId: selectedPhieu?.id,
      isConclusion: benhNhanHanhChinh?.concluded,
      isExamined: true,
      forDVKT: true,
      fulfillDeptCode: rowSelected?.fulfillDeptCode,
    });
  }, [benhNhanHanhChinh, rowSelected, thongTinChiPhi]);

  const handleGetThongTinChiPhi = async () => {
    try {
      const { data } = await getPaymentDetail(benhNhanHanhChinh?.visitId);
      if (CODE.SUCCESS === data?.code) {
        setThongTinChiPhi({
          tongChiPhi: data?.data?.ttTong,
          bhyt: data?.data?.ttBhyt,
          benhNhan: data?.data?.ttNguoiBenh,
          tamUng: data?.data?.ttTamUng,
          daThu: data?.data?.ttDaThu,
          mienGiam: data?.data?.ttDiscountInv,
          conDu: data?.data?.ttConNo,
        });
      }
    } catch (error) {
      console.error(error);
      toast.error('Xảy ra lỗi khi lấy thống tin chi phi, vui lòng thử lại!');
    }
  }

  const handleReset = () => {
    setDsPhieu([]);
    setSelectedPhieu(null);
    setDsDichVuDetail([]);
  };

  const handleClickClonePhieu = (phieu: any) => {
    setSelectedPhieuForClone(phieu);
    setOpenModalTachPhieu(true);
  };

  const handleSaveTachPhieu = async (selectedDates: any[]) => {
    try {
      if (!selectedDates || selectedDates.length === 0) {
        toast.warning('Vui lòng chọn ít nhất một ngày để sao phiếu');
        return;
      }

      setIsLoading(true);
      const payload = {
        orderGroupId: selectedPhieuForClone.id,
        treatmentId: benhNhanHanhChinh.treatmentId,
        autoPrescriptions: selectedDates.map(date => ({
          prescriptionDate: date.value,
          treatmentSheetId: date.treatmentSheetId || ""
        }))
      };

      const { data } = await cloneParaclinical(payload);

      if (data?.code === CODE.SUCCESS) {
        toast.success('Sao phiếu thành công');
        setOpenModalTachPhieu(false);
        setSelectedPhieuForClone(null);
        statusChangedEventFunc?.();
        handleGetDsPhieu();
      } else {
        let errorMessage = getErrorMessage(data);
        setValidateMessage(errorMessage);
        setShouldOpenConfirmDialog(true);
      }
    } catch (error) {
      console.error(error);
      toast.error('Xảy ra lỗi khi sao phiếu');
    } finally {
      setIsLoading(false);
    }
  };

  const actionChanged = (statusCode?: string) => {
    setCurrentStatusWf(statusCode);
    handleSelectPhieu(selectedPhieu);
    setIsUpdateWorkflow(!isUpdateWorkflow);
    handleGetDsPhieu();
    toast.success(RESPONSE_MESSAGE.SUCCESS);
  };

  const handleGetListICD10 = async () => {
    try {
      let res: IDanhSachDanhMuc = await getIndexedDBItem(
        KEY_DS_DANH_MUC_TIEP_DON
      );
      setListICD10(res?.listICD10 || []);
    } catch (error) {
      console.error(error);
    }
  };

  const handleClickWfButton = (data: any) => {
    setDynamicData({
      ...data,
      orderGroupId: selectedPhieu?.id,
      callbackFunc: () => {
        setSelectedIndex(0);
      },
      updateWorkflow: () => {
        setIsUpdateWorkflow(!isUpdateWorkflow);
      }
    });
  };

  const handleConfirmDelete = async () => {
    try {
      await deleteDSChiDinhDV(selectedPhieu?.id);
      setSelectedIndex(0);
      handleGetDsPhieu();
    } catch (error) {
      console.error(error);
      toast.error("Xảy ra lỗi, vui lòng thử lại!");
    }
  };

const handleGetDsPhieu = async () => {
    try {
      let { data } = await getDsPhieuDichVu(benhNhanHanhChinh?.treatmentId, ORDER_TYPE_ID.CHUYEN_KHOA, treatmentSheetId);
      if (CODE.SUCCESS === data?.code) {
        let dsPhieuConverted = data?.data?.map((item: any, index: number) => {
          return {
            ...item,
            index,
            date: moment(item?.indicationTime).format("DD/MM/YYYY"),
          };
        });
        let currentIndex = benhNhanHanhChinh?.treatmentId !== currentTreatmentId ? 0 : selectedIndex;
        setDsPhieu(dsPhieuConverted || []);
        handleSelectPhieu(dsPhieuConverted?.[currentIndex] || dsPhieuConverted?.[0]);
      } else {
        handleReset();
      }
    } catch (error) {
      console.error(error);
      handleReset();
    }
  }

  const handleSelectPhieu = async (dataPhieu: any) => {
    try {
      if (!dataPhieu) {
        handleReset();
        return;
      };
      setSelectedIndex(dataPhieu?.index);

      // Gọi song song 2 API: lấy danh sách dịch vụ và thông tin chỉ định
      const [dvResponse, indicationInfo] = await Promise.all([
        getDSDVDaChiDinh({
          orderGroupId: dataPhieu?.id,
          // type: ORDER_TYPE_ID.XET_NGHIEM,
        }),
        loadIndicationInfo(dataPhieu?.id) //  Sử dụng hook
      ]);

      // Merge data với indication info từ SurgeryGroup
      // QUAN TRỌNG: Giữ nguyên orderGroupId (dataPhieu.id), không để bị đè bởi SurgeryGroup.id
      const updatedPhieu = {
        ...dataPhieu,
        ...(indicationInfo || {}), // Chỉ merge khi có data
        id: dataPhieu.id, // Luôn giữ orderGroupId
        surgeryGroupId: indicationInfo?.id // Lưu SurgeryGroupId riêng nếu cần
      };
      setSelectedPhieu(updatedPhieu);

      // Xử lý danh sách dịch vụ
      if (CODE.SUCCESS === dvResponse?.data?.code) {
        const newData = dvResponse.data.data?.map((item: any) => {
          return {
            ...item,
            terms: item?.terms?.map((term: any) => {
              if (term?.subs) {
                return {
                  ...term,
                  status: item?.color,
                  name: (
                    <CheckIcon
                      data={term}
                      color={term?.statusColor}
                      className="ml-2"
                    />
                  ),
                  subs: term?.subs?.map((sub: any) => {
                    return {
                      ...sub,
                      isCancel: term?.isCancel,
                      name: <CheckIcon
                        data={{ ...sub, isCancel: term?.isCancel }}
                        color={term?.statusColor}
                      />,
                    };
                  }),
                };
              } else {
                return {
                  ...term,
                  status: item?.color,
                  name: <CheckIcon data={term} color={term?.statusColor} />,
                };
              }
            }),
          };
        });
        setDsDichVuDetail(newData || []);
      } else {
        setDsDichVuDetail([]);
      }
    } catch (error) {
      console.error(error);
      setDsDichVuDetail([]);
    }
  };

  const handleClearContext = () => {
    setItemService(null);
    setContextMenu?.(null);
  };

  const handleContextMenu = (e: any, row: any, parentRow?: any) => {
    e.preventDefault();
    try {
      // Là dvu
      if (row?.id) {
        setRowSelected({
          ...row,
          fulfillDept: parentRow?.fulfillDept,
          fulfillDeptCode: parentRow?.fulfillDeptCode,
        });
        setItemService(row)
        setContextMenu({ x: e.clientX, y: e.clientY });
      }
    } catch (error) {
      console.error(error);
    }
  };

  const handleViewResult = (data: any) => {
    if (!selectedPhieu?.isAllowModify || data?.statusCode === STATUS_CANCEL.BS_CANCEL) {
      return;
    };
    let isAllowEdit =
      data?.obs?.isAllowEdit ||
      (data?.terms ? data?.terms[0]?.obs?.isAllowEdit : null);
    let resultData = {
      ...data,
      ...data?.obs,
      ...data?.terms?.[0]?.obs,
    };
    if (isAllowEdit) {
      setShouldOpenResultModal(true);
      setSelectedRow(resultData);
    } else {
      toast.warning("Dịch vụ chưa được thanh toán!");
    }
  };

  const handleSubmitForm = async (
    values: any,
  ) => {
    let valuesPTTT = {
      ...values,
      surgeryInitialDiagnosis: values?.surgeryInitialDiagnosis?.code || null,
      surgeryComorbidity: values?.surgeryComorbidity?.code || null,
      surgeryPreoperativeDiagnosis:
        values?.surgeryPreoperativeDiagnosis?.code || null,
      surgeryPostoperativeDiagnosis:
        values?.surgeryPostoperativeDiagnosis?.code || null,
    };
    let dataSubmit = values?.allowDisableRules ? values : {
      personId: benhNhanHanhChinh?.personId,
      orderId: selectedRow?.orderId,
      values: valuesPTTT,
    };

    try {
      setIsLoading(true);
      await createObsValue(dataSubmit);
      toast.success("Lưu thực hiện thành công");
      handleSelectPhieu(selectedPhieu);
      setIsHasData(true);
    } catch (error) {
      console.error(error);
      toast.error("Xảy ra lỗi, vui lòng thử lại!");
    } finally {
      setIsLoading(false);
    }
  };

  const handleGetStatusDesc = async () => {
    try {
      let { data } = await getStatusDesc(WfConstTracker.SURGERY_ORDER);
      if (data?.code === CODE.SUCCESS) {
        setStatusDesc(data?.data);
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    if (!benhNhanHanhChinh?.treatmentId) return;
    handleGetListICD10();
    handleGetThongTinChiPhi();
    handleGetStatusDesc();
  }, [benhNhanHanhChinh?.treatmentId]);

  useEffect(() => {
    selectedPhieu && setCurrentStatusWf(selectedPhieu?.currStatusCode);
  }, [selectedPhieu]);

  useEffect(() => {
    setCurrentTreatmentId(benhNhanHanhChinh?.treatmentId);
  }, [benhNhanHanhChinh?.treatmentId]);

  useEffect(() => {
     benhNhanHanhChinh?.treatmentId && handleGetDsPhieu();
   }, [benhNhanHanhChinh?.treatmentId, statusChangedEvent, treatmentSheetId]);

  const columnsDSChuyenKhoa = [
		{
			title: 'Tên dịch vụ',
			field: 'name',
			className: 'spaces width-40',
			render: (rowData: any) => <CellFormatter rowData={rowData} value={rowData?.name} />,
		},
		{
			title: 'SL',
			field: 'quantity',
			className: 'spaces width-10 text-center',
			render: (rowData: any) => (
				<CellFormatter
					rowData={rowData}
					value={rowData?.isCancel ? 0 : rowData?.quantity ?? 1}
				/>
			),
		},
		{
			title: 'Kết quả',
			field: 'ketQua',
			className: 'spaces width-20',
			render: (rowData: any) => {
				const isFieldEnable = getWorkflowTrackerFieldConfig({
					workflowConfig: rowData?.additionalConfiguration,
					componentName: 'BangDsDichVuCK',
					field: 'obsValue',
				})?.write;

				return (
					<TableCustomCell
						className="s-2"
						data={
							<Formik
								initialValues={{}}
								onSubmit={() => {}}
								className="spaces w-100 fs-14"
							>
								{isFieldEnable ? (
									generateInput(rowData)
								) : (
                  <CellFormatter
										rowData={rowData}
										value={rowData?.obs?.value}
									/>
								)}
							</Formik>
						}
					/>
				);
			},
		},
		{
			title: 'Loại bệnh phẩm',
			field: 'type',
			className: 'spaces width-15',
			render: (rowData: any) => <CellFormatter rowData={rowData} value={rowData?.type} />,
		},
		{
			title: 'Đối tượng',
			field: 'doiTuong',
			className: 'spaces width-15',
			render: (rowData: any) => (
				<CellFormatter rowData={rowData} value={rowData?.objectTypeName} />
			),
		},
  ];

  const handleCancelService = async (value: any) => {
    try {
      const obj = {
        termType: TERM_TYPE.PTTT,
        termOrderId: rowSelected?.termOrderId,
        cancelReason: value?.canceledReason,
        menuAction: MENU_ACTION.KHAM_BENH,
        statusId: dynamicData?.statusReq?.status
      }
      
      let { data } = await cancelService(obj);
      if(CODE.SUCCESS === data?.code && data?.data) {
        toast.success("Bỏ dịch vụ thành công!");
        handleSelectPhieu(selectedPhieu);
        setSelectedIndex(0);
        handleClearContext();
      } else {
        toast.error(data?.message);
      }
    } catch (error) {
      console.error(error);
    }
  }

  const MemoDynamicComponent = useMemo(() => (
    <DynamicComponentXN
      data={dynamicData}
      setData={setDynamicData}
      handleCancelService={handleCancelService}
      generalInfo={generalInfo}
      onConfirm={handleConfirmDelete}
      isInpatient
    />
  ), [dynamicData?.componentName]);

  const handleSaveObs = async (rowData: any, value: any) => {
    try {
      if (value !== rowData?.obs?.value && (rowData?.obs?.value || value)) {
        setFieldLoading({ [rowData?.id]: true });
        
        const submitData = {
          personId: benhNhanHanhChinh?.personId,
          orderId: rowData?.obs?.orderId,
          values: {
            conclusion: value || null,
            surgeryPrimarySurgeon1st: rowData?.obs?.attributeValue?.surgeryPrimarySurgeon1st 
              || null,
            surgeryInformationEntryDepartment: rowData?.obs?.attributeValue?.surgeryInformationEntryDepartment
              || null,
          },
        };

        let { data } = await createObsValue(submitData);
        data?.code === CODE.SUCCESS && toast.success("Lưu kết luận thành công!");
        
        const newData = dsDichVuDetail?.map((item: any) => {
          return {
            ...item,
            terms: item?.terms?.map((itemTerm: any) => {
              if (itemTerm?.id === rowData?.id) {
                return {
                  ...itemTerm,
                  obs: {
                    ...itemTerm.obs,
                    value: value,
                  },
                };
              }
              return itemTerm;
            }),
          };
        });
        setDsDichVuDetail(newData);
        handleSelectPhieu(selectedPhieu);
      }
    } catch (error) {
      toast.warning("Lỗi lưu kết luận, vui lòng nhập lại!");
    } finally {
      setFieldLoading({});
    }
  };

  const generateInput = (rowData: any) => {
    return (
      <div className="d-flex align-items-center spaces w-100 py-3">
        <TextField
          className="spaces w-100"
          name="value"
          defaultValue={rowData?.obs?.value || ""}
          disabled={benhNhanHanhChinh?.concluded}
          onBlur={(e: FocusEvent<HTMLInputElement>) => {
            handleSaveObs(rowData, e.target.value);
          }}
        />
        {fieldLoading[rowData.id] && <span className="loading-spinner"></span>}
      </div>
    );
  };

  return (
    <Row className="h-100 spaces px-16 py-5">
      <div>
        <div className="spaces pt-13 h-80 bg-white">
          <Row className="mx-0">
            <Col xs={4} className="d-flex align-items-center mb-3">
              <LabelRequired label="Mã phiếu" className="min-w-100px" />
              <span className="fw-light text-truncate">
                {selectedPhieu?.code || "..."}
              </span>{" "}
            </Col>
            {/*  Sử dụng shared component */}
            <Col xs={4} className="d-flex align-items-center text-lable-input mb-3">
              <LabelRequired label="Ngày y lệnh" className="min-w-100px" />
              <TimeEditor
                name="indicationTime"
                values={selectedPhieu}
                isEditingTime={indicationTimeManager.isEditingTime}
                editedTime={indicationTimeManager.editedTime}
                showValidationConfirm={indicationTimeManager.showValidationConfirm}
                validationMessage={indicationTimeManager.validationMessage}
                onEdit={indicationTimeManager.handleEditTime}
                onCancel={indicationTimeManager.handleCancelEdit}
                onSave={indicationTimeManager.handleSaveTime}
                onConfirmValidation={indicationTimeManager.handleConfirmValidation}
                onCancelValidation={indicationTimeManager.handleCancelValidation}
                onTimeChange={indicationTimeManager.setEditedTime}
                allowEdit={allowEdit}
              />
            </Col>
            <Col
              xs={4}
              className="d-flex align-items-center text-lable-input mb-3"
            >
              <LabelRequired label="Người chỉ định" className="min-w-100px" />
              <SelectEditor
                name="indicationPerson"
                values={{
                  indicationPerson: selectedPhieu?.indicationPerson
                }}
                options={[]}
                searchFunction={seachUserMetadata}
                searchObject={{ position: 1 }}
                urlData="data.content"
                getOptionLabel={(opt) => opt?.fullName || ""}
                inline={true}
                menuPlacement="top"
                isEditingSelect={indicationPersonSelectManager.isEditingSelect}
                editedValue={indicationPersonSelectManager.editedValue}
                showValidationConfirm={indicationPersonSelectManager.showValidationConfirm}
                showConfirmWithReason={indicationPersonSelectManager.showConfirmWithReason}
                validationMessage={indicationPersonSelectManager.validationMessage}
                onEdit={indicationPersonSelectManager.handleEditSelect}
                onCancel={indicationPersonSelectManager.handleCancelEdit}
                onSave={indicationPersonSelectManager.handleSaveSelect}
                onConfirmValidation={indicationPersonSelectManager.handleConfirmValidation}
                onCancelValidation={indicationPersonSelectManager.handleCancelValidation}
                onConfirmWithReason={indicationPersonSelectManager.handleConfirmWithReason}
                onCancelWithReason={indicationPersonSelectManager.handleCancelWithReason}
                onValueChange={indicationPersonSelectManager.setEditedValue}
                allowEdit={allowEdit}
              />
            </Col>
            <Col
              xs={4}
              className="d-flex align-items-center text-lable-input mb-3"
            >
              <LabelRequired label="Nơi chỉ định" className="min-w-100px" />
              <SelectEditor
                name="requestDeptName"
                values={{
                  requestDeptName: selectedPhieu?.requestDeptName
                }}
                options={danhSachDanhMuc?.listPhongKham || []}
                inline={true}
                menuPlacement="top"
                isEditingSelect={requestDeptNameSelectManager.isEditingSelect}
                editedValue={requestDeptNameSelectManager.editedValue}
                showValidationConfirm={requestDeptNameSelectManager.showValidationConfirm}
                showConfirmWithReason={requestDeptNameSelectManager.showConfirmWithReason}
                validationMessage={requestDeptNameSelectManager.validationMessage}
                onEdit={requestDeptNameSelectManager.handleEditSelect}
                onCancel={requestDeptNameSelectManager.handleCancelEdit}
                onSave={requestDeptNameSelectManager.handleSaveSelect}
                onConfirmValidation={requestDeptNameSelectManager.handleConfirmValidation}
                onCancelValidation={requestDeptNameSelectManager.handleCancelValidation}
                onConfirmWithReason={requestDeptNameSelectManager.handleConfirmWithReason}
                onCancelWithReason={requestDeptNameSelectManager.handleCancelWithReason}
                onValueChange={requestDeptNameSelectManager.setEditedValue}
                allowEdit={allowEdit}
              />
            </Col>
            <Col
              xs={8}
              className="d-flex align-items-center text-lable-input mb-3"
            >
              <LabelRequired label="Chẩn đoán" className="min-w-100px" />
              <span className="fw-light text-truncate">
                {selectedPhieu?.provisionalDiagnosisName || "..."}
              </span>
            </Col>
          </Row>
        </div>
        <div className="bg-white spaces pt-2 mb-6">
          <DanhSachPhieu
            className="mb-2"
            dsPhieu={dsPhieu || []}
            handleSelectRowData={handleSelectPhieu}
            selectedIndex={selectedIndex}
            additionalActions={[
              {
                iconClassName: "fa fa-clone",
                tooltip: "Sao phiếu",
                onClick: handleClickClonePhieu
              }
            ]}
          />
          <TableCollapseCustom
            columns={columnsDSChuyenKhoa}
            data={dsDichVuDetail || []}
            childrenField="subs"
            className={`overflow-auto spaces h-calc-vh-335`}
            handleDoubleClick={handleViewResult}
            handleContextMenu={handleContextMenu}
          />
          <div className="d-flex justify-content-between p-2 gap-3 bg-white">
            <div className="d-flex">
              {benhNhanHanhChinh?.visitId && benhNhanHanhChinh?.patientId && selectedPhieu?.id && WORKFLOW_ORDER_GROUP_STATUS_CODE.HUY_GUI_PHIEU !== currentStatusWf && (
                <>
                  <ButtonIn
                    className="spaces mx-3"
                    label="Phiếu chỉ định chung"
                    fetchExport={inPhieuChiDinhChung}
                    params={{
                      visitId: benhNhanHanhChinh?.visitId,
                      patientId: benhNhanHanhChinh?.patientId,
                      orderGroupId: selectedPhieu?.id,
                    }}
                  />
                  <ButtonIn
                    className="spaces mx-3"
                    label="Phiếu chỉ định theo phòng"
                    fetchExport={inPhieuChiDinhChung}
                    params={{
                      visitId: benhNhanHanhChinh?.visitId,
                      patientId: benhNhanHanhChinh?.patientId,
                      orderGroupId: selectedPhieu?.id,
                      isSplit: true
                    }}
                  />
                  <ButtonIn
                    className="spaces mx-3"
                    label="Phiếu chỉ định (F2)"
                    fetchExport={inPhieuChiDinhCLS}
                    params={{
                      visitId: benhNhanHanhChinh?.visitId,
                      patientId: benhNhanHanhChinh?.patientId,
                      orderGroupId: selectedPhieu?.id,
                      orderTypeId: ORDER_TYPE_ID.CHUYEN_KHOA,
                    }}
                    keyBtn={KEY.F2}
                  />
                </>
              )}
              {selectedPhieu?.isAllowModify && !benhNhanHanhChinh?.concluded && allowOrder && (
                <WfButton
                  tracker={WfConstTrackerClinical.ORDER_GROUP}
                  objectId={selectedPhieu?.id}
                  additionalFunc={actionChanged}
                  handleClick={handleClickWfButton}
                  forceRender={isUpdateWorkflow}
                />
              )}

              {dynamicData && MemoDynamicComponent}

              {shouldOpenResultModal && (
                <ModalThucHien
                  handleClose={() => {
                    handleSelectPhieu(selectedPhieu);
                    setShouldOpenResultModal(false);
                    setIsHasData(false);
                  }}
                  handleTraKetQua={() => { }}
                  infoBenhNhan={selectedPhieu}
                  selectedRow={selectedRow}
                  handleSubmitForm={handleSubmitForm}
                  listICD10={listICD10}
                  isHasData={isHasData}
                  setIsHasData={setIsHasData}
                  isViewModal={benhNhanHanhChinh?.concluded}
                />
              )}

              {!rowSelected?.isCancel && contextMenu && (
                <WfContextMenu
                  handleCloseMenu={() => {
                    handleClearContext();
                  }}
                  target={contextMenu}
                  tracker={WfConstTracker.SURGERY_ORDER}
                  objectId={itemService?.termOrderId}
                  additionalFunc={actionChanged}
                  componentName="TabChuyenKhoa"
                  handleClick={(data) => {
                    handleClickWfButton(data)
                  }}
                />
              )}
            </div>
            <ShowStatus className="status-summary" statuses={statusDesc} />
          </div>
        </div>
      </div>

      {openModalTachPhieu && (
        <ModalChonNgay
          open={openModalTachPhieu}
          onClose={() => {
            setOpenModalTachPhieu(false);
            setSelectedPhieuForClone(null);
          }}
          onSave={handleSaveTachPhieu}
          treatmentId={benhNhanHanhChinh?.treatmentId}
        />
      )}

      {shouldOpenConfirmDialog && (
        <ConfirmDialog
          className="z-index-1060"
          show={shouldOpenConfirmDialog}
          title="Thông báo"
          message={validateMessage}
          close="Đóng"
          onCloseClick={() => {
            setValidateMessage('');
            setShouldOpenConfirmDialog(false);
          }}
        />
      )}
    </Row>
  );
}

export default ChuyenKhoa